import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { NOTIFICATIONS_FEATURE_GROUP } from './group';

export const NOTIFICATIONS_FEATURES = {
  READ: {
    guid: 'e6a1b83b-a8fe-4044-a2dd-b33291d4aaae',
    name: 'notifications:read',
    description: 'View notification preferences',
    action: 'read',
    product: 'account',
    parentGuid: NOTIFICATIONS_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: '899d8291-294a-4de9-b15d-0dbd4e956e8a',
    name: 'notifications:update',
    description: 'Edit notification preferences',
    action: 'update',
    product: 'account',
    parentGuid: NOTIFICATIONS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { NOTIFICATIONS_FEATURE_GROUP } from './group';

export const NOTIFICATIONS_MODULE: FeatureModule = {
  product: 'account',
  groups: [NOTIFICATIONS_FEATURE_GROUP],
  features: featureList(NOTIFICATIONS_FEATURES),
};
